import { Link } from 'react-router-dom';

export default function FeaturesHero() {
  return (
    <section className="pt-32 pb-20 px-6 bg-gradient-to-br from-gray-50 via-white to-teal-50/30 relative overflow-hidden">
      {/* Decorative blobs */}
      <div className="absolute top-20 right-20 w-64 h-64 bg-teal-100/40 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-10 w-48 h-48 bg-emerald-100/30 rounded-full blur-2xl pointer-events-none" />

      <div className="max-w-7xl mx-auto relative">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-teal-50 border border-teal-100 rounded-full px-4 py-1.5 mb-6">
            <span className="w-2 h-2 bg-teal-500 rounded-full animate-pulse" />
            <span className="text-xs font-medium text-teal-700 uppercase tracking-wider">Full Platform Overview</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-semibold text-gray-900 leading-tight tracking-tight mb-5">
            Every Tool Your Travel Agency Needs —{' '}
            <span className="bg-gradient-to-r from-teal-500 to-emerald-500 bg-clip-text text-transparent">
              Powered by AI
            </span>
          </h1>
          <p className="text-lg text-gray-500 leading-relaxed mb-8 max-w-2xl">
            TreWaz automates the full customer journey — from capturing a lead on your website, through WhatsApp conversations, itinerary building, quote sending, payment confirmation, and post-booking follow-ups. No more chasing, no more manual typing.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/register"
              className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-teal-500 to-emerald-500 text-white text-sm font-medium px-6 py-3 rounded-md hover:from-teal-600 hover:to-emerald-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Start Free Trial
              <i className="ri-arrow-right-line" />
            </Link>
            <a
              href="#lead-capture"
              className="inline-flex items-center justify-center gap-2 border border-gray-200 text-gray-700 text-sm font-medium px-6 py-3 rounded-md hover:border-teal-300 hover:text-teal-700 transition-all whitespace-nowrap cursor-pointer"
            >
              Explore All Features
              <i className="ri-arrow-down-line" />
            </a>
          </div>
        </div>

        {/* Module quick-nav pills */}
        <div className="mt-14 flex flex-wrap gap-2">
          {[
            { icon: 'ri-focus-3-line', label: 'Lead Capture', href: '#lead-capture' },
            { icon: 'ri-whatsapp-line', label: 'WhatsApp AI', href: '#whatsapp-ai' },
            { icon: 'ri-robot-2-line', label: 'AI Assistant', href: '#ai-assistant' },
            { icon: 'ri-map-2-line', label: 'Itinerary Builder', href: '#itinerary-builder' },
            { icon: 'ri-file-paper-2-line', label: 'Quote & PDF', href: '#quote-builder' },
            { icon: 'ri-secure-payment-line', label: 'Payment & Confirmation', href: '#payment' },
            { icon: 'ri-refresh-line', label: 'Follow-up & CRM', href: '#followup' },
          ].map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="flex items-center gap-1.5 bg-white border border-gray-100 text-gray-600 text-xs font-medium px-4 py-2 rounded-full hover:border-teal-300 hover:text-teal-700 hover:bg-teal-50/50 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className={`${item.icon} text-teal-500`} />
              {item.label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
